import request from '@/utils/http'
import { createCourseRegenerationStreamParser } from '@/utils/courseRegeneration.mjs'

export function stream (params, onMessage) {
  return request.streamNew({
    url: '/api/course/generate/stream',
    params,
    onMessage
  })
}
export function detail (params) {
  return request.get({
    url: '/api/course/detail',
    params
  })
}
export function getLearningContext (params) {
  return request.get({
    url: '/api/student/course/learning-context',
    params,
    config: { suppressGlobalError: true }
  })
}
export function completeStage ({ id }) {
  return request.post({
    url: `/api/course/${id}/complete-stage`
  })
}

/**
 * 根据最新测试结果重新生成课程 Stage 1。
 *
 * @param {Object} options
 * @param {number|string} options.courseId
 * @param {number|string|null} options.sourceTestRecordId
 * @param {'en'|'fr'} options.language
 * @param {(content: string) => void} options.onContent
 * @param {Object} options.cancelToken
 * @returns {Promise<Object>}
 */
export function regenerateCourseStream ({
  courseId,
  sourceTestRecordId,
  language = 'en',
  onContent,
  cancelToken
}) {
  const parser = createCourseRegenerationStreamParser({ onContent })
  const parsedTestRecordId = Number(sourceTestRecordId)
  const normalizedTestRecordId = Number.isInteger(parsedTestRecordId) && parsedTestRecordId > 0
    ? parsedTestRecordId
    : null

  return request.streamSse({
    url: `/api/course/${courseId}/regenerate/stream`,
    params: {
      sourceTestRecordId: normalizedTestRecordId,
      language
    },
    onMessage: (event) => parser.push(event),
    config: {
      cancelToken,
      suppressGlobalError: true,
      headers: {
        Accept: 'text/event-stream'
      }
    }
  }).then(() => {
    const result = parser.finish()
    if (result.error) {
      const error = new Error(result.error.message)
      error.code = result.error.code
      throw error
    }
    return result.course
  })
}

export function getCourseHistory (params) {
  return request.get({
    url: '/api/course/history',
    params
  })
}

export function getCourseHistoryDetail ({ historyId, language = 'en' }) {
  return request.get({
    url: `/api/course/history/${historyId}`,
    params: { language }
  })
}
